import { Config } from "../../../api/config";
export var ContractInvoiceKeys = {
    Paging: 'contractInvoicePaging',
    ExecutiveListKey: 'executiveListKey',
    PaymentModeListKey: 'paymentModeKey',
    PaymentTypeListKey: "paymentTypeListKey",
    PaymentTermListKey: "paymentTypeTermListKey",
    getCSI: "getCSIkey",
    ContractInvoiceUpsertKey: "contractInvoicePaymentUpsert",
    InstallBaseListKey: "installBaseListKey",
    SearchByMobNoKey: "searchByMobNoKey",
    SearchByOrderNo: "SearchByOrderNoKey",
    ActiveContracts: "activeContractsKey",
    NewContractKey: 'newContractKey',
    GetServiceContractDetailsKey: 'getServiceContractDetailsKey',
    CustomerDetailsKey: 'customerDetailsKey',
    ContractSaleInvoiceCount: 'contractSaleInvoiceCount'
};
export var JSIAttachmentAPIKeys = {
    create: 'jsiAttachmentCreate',
    upload: 'jsiAttachmentUpload'
};
//------------------ Contract sale Invoice URL ------------------------------------
// export const ExecutiveListAPI = `${Config.baseURL}Employee/ExecutiveList`;
export var ExecutiveListAPI = function (id) {
    return "".concat(Config.baseURL, "Employee/ExecutiveList");
};
export var PaymentModeListURL = "".concat(Config.baseURL, "PaymentMode/List");
export var paymentTypeListURL = "".concat(Config.baseURL, "PaymentType/List");
export var paymentTermListURL = "".concat(Config.baseURL, "PaymentTerm/List");
export var CSIPagingAPI = "".concat(Config.baseURL, "ContractSaleInvoice/PagingContractSaleInvoice");
export var contractSaleOrderGet = function (id) {
    return "".concat(Config.baseURL, "ContractSaleOrder/").concat(id, "/Get");
};
export var customerDetailsGet = function (id) {
    return "".concat(Config.baseURL, "Customer/").concat(id, "/Get");
};
export var InstallBaseListURL = "".concat(Config.baseURL, "Installbase/ChannelInstallbaseData");
export var ActiveContractURL = "".concat(Config.baseURL, "Installbase/FindActiveContract");
export var NewContractURL = "".concat(Config.baseURL, "ServiceContract/GetNewContracts");
export var UpsertNewContractURL = "".concat(Config.baseURL, "ContractSaleInvoice/UpsertContractSaleInvoice");
export var GetServiceContractDetailsURL = function (id) {
    return "".concat(Config.baseURL, "ServiceContract/").concat(id, "/GetServiceContractDetails");
};
export var searchByOrderNoURL = "".concat(Config.baseURL, "ContractSaleInvoice/SearchOrders");
export var searchByMobNoURL = "".concat(Config.baseURL, "Person/ByMobileNo");
export var invoiceSaleCountURL = "".concat(Config.baseURL, "ContractSaleInvoice/StatusCount");
//--------------------Attachment URL ---------------
export var JsiAttachmentCreateAPI = "".concat(Config.baseURL, "InvoiceDocumentAttachment/Create");
export var JsiAttachmentUploadAPI = function (id) {
    return "".concat(Config.baseURL, "resource/InvoiceDocumentAttachment/").concat(id);
};
